import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowCornerRightUp: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-corner-right-up"><path d="M4.75 20.25H15.25V4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.25 7.75L15.25 3.75L19.25 7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowCornerRightUp;
